// Formateadores de fechas centralizados

/**
 * Parsea un string YYYY-MM-DD como fecha local (medianoche en la zona del usuario).
 * Evita el bug de new Date("YYYY-MM-DD") que interpreta como UTC y desplaza el día en zonas UTC-X.
 */
export const parseLocalDate = (dateStr: string): Date => {
  if (!dateStr || typeof dateStr !== 'string') {
    return new Date(NaN);
  }
  const parts = dateStr.split('-').map(Number);
  if (parts.length < 3 || parts.some(isNaN)) {
    return new Date(NaN);
  }
  const [year, month, day] = parts;
  // month es 1-12 en ISO, Date usa 0-11
  return new Date(year, month - 1, day);
};

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) return '';

    return dateObj.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  } catch (error) {
    console.warn('Error formatting date:', error);
    return '';
  }
};

export const formatDateTime = (date: string | Date | null | undefined): string => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) return '';

    return dateObj.toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.warn('Error formatting datetime:', error);
    return '';
  }
};

export const formatTime = (date: string | Date | null | undefined): string => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) return '';

    return dateObj.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.warn('Error formatting time:', error);
    return '';
  }
};

export const formatRelativeTime = (date: string | Date | null | undefined): string => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - dateObj.getTime()) / 1000);

    if (diffInSeconds < 60) return 'Hace un momento';
    if (diffInSeconds < 3600) return `Hace ${Math.floor(diffInSeconds / 60)} minutos`;
    if (diffInSeconds < 86400) return `Hace ${Math.floor(diffInSeconds / 3600)} horas`;
    if (diffInSeconds < 2592000) return `Hace ${Math.floor(diffInSeconds / 86400)} días`;

    return formatDate(dateObj);
  } catch (error) {
    console.warn('Error formatting relative time:', error);
    return '';
  }
};

export const formatDateRange = (
  startDate: string | Date | null,
  endDate: string | Date | null,
): string => {
  const start = formatDate(startDate);
  const end = formatDate(endDate);

  if (!start && !end) return '';
  if (!start) return `Hasta ${end}`;
  if (!end) return `Desde ${start}`;

  return `${start} - ${end}`;
};
